<template>
  <div class="f-p">
    <div class="f-p-data">
      <fm-table
        :column-list="columnList"
        :data-list="[{}].concat(dataList)"
        @tableAction="tableAction"
        :table-actions="tableActions">
      </fm-table>
    </div>
    <fm-form-dialog
      :mask-closable="false"
      form-title="列"
      :open-dialog.sync="openDialog"
      :form-parms="formParms"
      :old-data="chooseData"
      label-alone
      label-align="left"
      form-width="800px"
      @formSubmit="formSubmit"
      @handleClose="handleClose">
    </fm-form-dialog>
  </div>
</template>

<script>
let dcopy = require('deep-copy')

export default {
  name: 'column',
  props: {
    value: Array
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  watch: {
    value: {
      handler () {
        this.dataList = dcopy(this.value)
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    columnList () {
      return [{
        title: '列名',
        field: 'column'
      },
      {
        title: '别名',
        field: 'alias'
      }]
    },
    formParms () {
      return [{
        type: 'input',
        label: '列名',
        key: 'column',
        check: {
          required: true
        }
      },
      {
        type: 'input',
        label: '别名',
        key: 'alias'
      }]
    }
  },
  data () {
    return {
      isNew: false,
      chooseData: null,
      tableActions: [{
        key: 'add',
        label: '新增',
        show: (data) => {
          return !data.column
        }
      },
      {
        key: 'del',
        label: '删除',
        show: (data) => {
          return data.column
        }
      }],
      dataList: [],
      openDialog: false
    }
  },
  methods: {
    tableAction (parm) {
      if (parm.action === 'add') {
        this.isNew = true
        this.chooseData = null
        this.openDialog = true
      } else if (parm.action === 'del') {
        this.chooseData = parm.data
        this.dataList = this.dataList.filter(v => v.column !== this.chooseData.column)
        this.$emit('change', this.dataList.map((v) => {
          let a = {}
          Object.keys(v).forEach((v2) => {
            a[v2] = v[v2]
          })
          return a
        }))
      }
    },
    handleClose () {
      this.openDialog = false
    },
    formSubmit (data, resolve) {
      if (this.isNew) {
        this.dataList.push(data)
      } else {
        let i = 0
        while (i < this.dataList.length) {
          if (this.dataList[i].key === data.key) {
            this.dataList[i] = data
          }
          i += 1
        }
      }
      this.$emit('change', this.dataList.map((v) => {
        let a = {}
        Object.keys(v).forEach((v2) => {
          a[v2] = v[v2]
        })
        return a
      }))
      resolve()
      this.openDialog = false
    },
    conf () {
      this.openDialog = true
    }
  }
}
</script>

<style lang="less" scoped>
.f-p {
  align-items: center;
  margin-left: 1rem;
  width: calc(100% - 1rem);
  .f-p-data {
    border: 1px solid #dcdee2;
    border-top: 0px;
    height: 10rem;
    width: calc(100% - 1rem);
  }
}
</style>
